import { render, staticRenderFns } from "./reward_rules.vue?vue&type=template&id=4869db9c&scoped=true"
import script from "./reward_rules.vue?vue&type=script&lang=js"
export * from "./reward_rules.vue?vue&type=script&lang=js"
import style0 from "./reward_rules.vue?vue&type=style&index=0&id=4869db9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4869db9c",
  null
  
)

export default component.exports